import { render, staticRenderFns } from "./Historia_clinica.vue?vue&type=template&id=58901d11&scoped=true"
import script from "./Historia_clinica.vue?vue&type=script&lang=js"
export * from "./Historia_clinica.vue?vue&type=script&lang=js"
import style0 from "./Historia_clinica.vue?vue&type=style&index=0&id=58901d11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58901d11",
  null
  
)

export default component.exports